import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./styles/HeroSection.css";

import heroImage from "../../../assets/images/hero-section/one.png";
import recruiterImg from "../../../assets/images/hero-section/two.png";
import colocationImg from "../../../assets/images/hero-section/three.png";
import auditImg from "../../../assets/images/hero-section/four.png";
import supportImg from "../../../assets/images/hero-section/five.png";
import strategyImg from "../../../assets/images/hero-section/six.png";

const ROTATING_TEXTS = [
  "Network Infrastructure",
  "Cybersecurity",
  "Cloud Systems",
  "Enterprise IT",
];

const HeroSection = () => {
  const navigate = useNavigate();
  const [activeText, setActiveText] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveText((prev) => (prev + 1) % ROTATING_TEXTS.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">
      <div className="hero__background" />
      <div className="hero__overlay" />
      <div className="hero__grid" />

      <div className="hero__content">
        {/* LEFT SIDE */}
        <motion.div
          className="hero__text"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero__eyebrow">
            Enterprise IT consulting & engineering
          </div>

          <h1 className="hero__title">
  Delivering Secure
  <span className="hero__gradient">
    Enterprise IT Solutions
  </span>
</h1>

<div className="hero__rotating">
  <AnimatePresence mode="wait">
    <motion.span
      key={activeText}
      className="hero__rotating-text"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      {ROTATING_TEXTS[activeText]}
    </motion.span>
  </AnimatePresence>
</div>

          <p className="hero__subtitle">
            Secure, scalable and high-performance infrastructure engineered
            for modern enterprises. We design, deploy and manage IT ecosystems
            that power growth.
          </p>

          <div className="hero__actions">
            <button
              className="hero__cta-btn hero__cta-btn--primary"
              onClick={() => navigate("/contact")}
            >
              Let’s Talk
            </button>

            <button
              className="hero__cta-btn hero__cta-btn--secondary"
              onClick={() => navigate("/about")}
            >
              Learn More
            </button>
          </div>

        </motion.div>

        {/* RIGHT SIDE */}
        <motion.div
          className="hero__visual"
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero__visual-ring" />

          <div className="hero-image-jumble">
            <img src={heroImage} alt="" className="jumble-img ji-1" />
            <img src={recruiterImg} alt="" className="jumble-img ji-2" />
            <img src={colocationImg} alt="" className="jumble-img ji-3" />
            <img src={auditImg} alt="" className="jumble-img ji-4" />
            <img src={supportImg} alt="" className="jumble-img ji-5" />
            <img src={strategyImg} alt="" className="jumble-img ji-6" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;